import { Component, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { User } from './user-model';
import { UserEditComponent } from '../user-edit/user-edit.component';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { Title } from '@angular/platform-browser';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { map } from 'rxjs/operators';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../nav-menu/user-company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})

export class UserComponent implements OnInit, OnDestroy {
  private users: User[] = [];
  private dataTable: any;
  private dtTable: any;
  private navbarHeadline: any;
  private modalId: string;
  private subs = new SubSink();

  @ViewChild('editModal', { static: false }) editModal: UserEditComponent;
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private repository: HttpRepositoryService, private titleService: Title,
    private antiForgery: AntiForgeryTokenService, private companyService: UserCompanyService) { }

  ngOnInit() {
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });
    
    this.dataTable = $('#userTable');
    this.navbarHeadline = $('#navbarHeadline');
    this.navbarHeadline.html(' Users');
    this.modalId = 'userModalMsg';
    this.createDataTable();
    this.loadData();
  }

  private createDataTable() {
    var that = this;

    var dtOptions = {
      data: this.users,
      columns: [
        {
          name: 'id',
          visible: false
        },
        {
          name: 'firstName'
        },
        {
          name: 'lastName'
        },
        {
          name: 'userName'
        },
        {
          name: 'email',
        },
        {
          name: 'emailConfirmed',
          class: 'text-center',
          filterable: false,
          width: '100px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        }
      ],
      orderBy: [[1, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-edit pr-3"></i> Edit',
          class: 'editrow',
          dataAttributes: ['id'],
          action: function (id) {
            that.edit(id);
          }
        },
        {
          text: '<i class="fas fa-trash pr-3"></i> Remove',
          class: 'deleterow',
          dataAttributes: ['id'],
          action: function (id) {
            that.delete(id);
          }
        }
        ]
      },
      buttons: [{
        text: '<i class="fas fa-plus"></i>',
        class: '',
        action: function () {
          that.create()
        }
      },
      {
        text: '<i class="fas fa-trash-alt"></i>',
        class: '',
        action: function () {
          that.deleteList()
        }
      }]
    };

    if (this.dtTable)
      this.dtTable.Destroy();

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  }

  private loadData() {
    this.subs.sink = this.repository.get<User[]>('api/Admin/List').pipe(map(x => x.data)).subscribe(resp => {
      this.users = resp;
      this.createDataTable();
    });
  }

  private create() {
    this.editModal.show(new User(), true);
  }

  private edit(id) {
    let user = this.users.find(x => x.id == id);

    this.subs.sink = this.repository.get<User>('api/Admin/Details/' + user.id.toString()).pipe(map(x => x.data)).subscribe((data: User) => {
      this.editModal.show(data, false);
    });
  }

  private delete(id) {
    let user = this.users.find(x => x.id === id);

    if (user) {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete user', 'error');
        } else {
          this.msgDialog.show("Are you sure you want to delete " + user.email + "?", MessageType.YESNO, 'Delete confirmation!', () => {
            this.subs.sink = this.repository.del('api/Admin/Remove/' + user.id, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete user', 'error');
              } else {
                Toast.Show('User successfully removed.', 'Delete user', 'success');
                this.loadData();
              }

            });
          });
        }
      });
    }
  }

  private deleteList() {
    let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.id);

    if (checked.length == 0) {
      this.msgDialog.show("You must select user(s)!", MessageType.OK, "Delete conformation!");
    } else {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete user', 'error');
        } else {
          this.msgDialog.show("Are you sure you want do delete " + checked.length + " user(s)?", MessageType.YESNO, "Delete conformation", () => {
            this.subs.sink = this.repository.post<number[]>('api/Admin/ListRemove', checked, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete user', 'error');
              } else {
                Toast.Show('User successfully removed.', 'Delete user', 'success');
                this.loadData();
              }
            });
          });
        }
      });
    }
  }

  private onSaved(data: User) {
    let user = this.users.find(x => x.id == data.id);

    if (user) {
      user.firstName = data.firstName;
      user.lastName = data.lastName;
      user.email = data.email;
      user.image = data.image;
      user.emailConfirmed = data.emailConfirmed;
    } else {
      this.users.push(data);
    }

    this.createDataTable();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }
  }
}
